import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// NG MODULES
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CitySearchComponent } from './components/city-search/city-search.component';
import { StateSearchComponent } from './components/state-search/state-search.component';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';
import { ViewImageComponent } from './components/view-image/view-image.component';
import { PendingChangesComponent } from './components/pending-changes/pending-changes.component';
import { CalendarWeekComponent } from './components/calendar-week/calendar-week.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter } from '@angular/material/core';
import { WeekDateAdapter } from '../shared/services/weekdayAdapter';
import { DateInputComponent } from './components/date-input/date-input.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CustomDateFormatPipe } from './pipes/custom-date-format';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { HasRoleDirective } from './directives/has-role.directive';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';




@NgModule({
  declarations: [
    CitySearchComponent,
    StateSearchComponent,
    CustomToastComponent,
    ViewImageComponent,
    PendingChangesComponent,
    CalendarWeekComponent,
    DateInputComponent,
    CustomDateFormatPipe,
    BackButtonComponent,
    // DateFormatDirective,
    // CustomDateFormatPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    BsDatepickerModule,
    // Directivas standalone
    HasPermissionDirective,
    HasRoleDirective,
    // BrowserAnimationsModule
    // DateFormatDirective,
    
    
  ],
  exports: [
    CitySearchComponent,
    StateSearchComponent,
    CustomToastComponent,
    ViewImageComponent,
    CalendarWeekComponent,
    DateInputComponent,
    BsDatepickerModule,
    CustomDateFormatPipe,
    BackButtonComponent,
    // Exportar directivas standalone para que estén disponibles en otros módulos
    HasPermissionDirective,
    HasRoleDirective,
    // DateFormatDirective,
    
  ],
    providers: [
      { provide: DateAdapter, useClass: WeekDateAdapter },
    ],
})
export class SharedModule { }
